import * as React from 'react';
import { Hooks } from '@grandvisionhq/carts-v2';
import { useOrder, createContainsHelper } from '@grandvisionhq/fun-orders';
import { useIntl } from '@grandvisionhq/state';
import { pushPurchaseEventToDataLayer, trackOrderCompletionEvents } from '../data-layer.js';
import { OrderConfirm } from './OrderConfirm.js';
import { useOrderConfirmLabels } from './hooks/use-order-confirm-labels.js';

const OrderConfirmContainerV2 = ({ logo , orderData: orderToken , cartId  })=>{
    const [, { reset  }] = Hooks.useCartStorage();
    const { getOrderByToken , order , error , loading , onCompleted  } = useOrder();
    const labels = useOrderConfirmLabels(order);
    const { currency  } = useIntl();
    const contains = React.useMemo(()=>{
        return createContainsHelper(order === null || order === void 0 ? void 0 : order.lineItems);
    }, [
        order === null || order === void 0 ? void 0 : order.lineItems
    ]);
    React.useEffect(()=>{
        if (orderToken) {
            getOrderByToken(orderToken);
        }
    // Only `orderToken` needed in the dep. array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        orderToken
    ]);
    React.useEffect(()=>{
        onCompleted(()=>{
            // Reset Cart when order data has been fetched successfully
            reset();
        });
    }, [
        onCompleted,
        reset
    ]);
    React.useEffect(()=>{
        if (order) {
            pushPurchaseEventToDataLayer(order, currency, cartId);
            trackOrderCompletionEvents(order, currency);
        }
    }, [
        cartId,
        currency,
        order
    ]);
    return /*#__PURE__*/ React.createElement(OrderConfirm, {
        order: order,
        logo: logo,
        labels: labels,
        contains: contains,
        error: error,
        isLoading: loading
    });
};

export { OrderConfirmContainerV2 };
//# sourceMappingURL=OrderConfirmContainerV2.js.map
